import React from 'react';
import { ActionMenu } from '@milanote/roma/application';
import type { MenuSize } from '@milanote/roma';
import useDividerAction from './useDividerAction';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import useInsertMenuNodes from './useInsertMenuNodes';
import useInsertMentionAction from './useInsertMentionAction';

export type InsertMenuToolbarPopupProps = {
    closePopup: () => void;
    size: MenuSize;
    onEmoji: () => void;
    onLinkBoard: () => void;
    element?: ImMNElement;
};

const InsertMenuToolbarContent: React.FC<InsertMenuToolbarPopupProps> = ({
    closePopup,
    size = 'xs',
    onEmoji,
    onLinkBoard,
    element,
}) => {
    const insertDividerLine = useDividerAction();
    const handleInsertMention = useInsertMentionAction();

    const popupAction = (action: () => void) => () => {
        closePopup();
        action();
    };

    const nodes = useInsertMenuNodes({
        element,
        actions: {
            insertEmoji: popupAction(onEmoji),
            insertBoardLink: popupAction(onLinkBoard),
            insertDividerLine: popupAction(insertDividerLine),
            insertMention: popupAction(handleInsertMention),
        },
    });

    return <ActionMenu.Content aria-label="Insert menu actions" nodes={nodes} autoFocus size={size} showIcons />;
};

export default InsertMenuToolbarContent;
